// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Starjout";
  src: url("https://cdn-alpha.inspiration.co/fonts/Starjout.ttf") format("truetype");
}
@font-face {
  font-family: "Starjhol";
  src: url("https://cdn-alpha.inspiration.co/fonts/Starjhol.ttf") format("truetype");
}
@font-face {
  font-family: "Starjedi";
  src: url("https://cdn-alpha.inspiration.co/fonts/Starjedi.ttf") format("truetype");
}
@font-face {
  font-family: TradeGothic;
  src: url("https://cdn-alpha.inspiration.co/fonts/Trade-Gothic-Bold.otf") format("opentype");
}
body {
  background: black;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/styles/base.scss"],"names":[],"mappings":"AACA;EACE,uBAAA;EACA,kFAAA;AAAF;AAEA;EACE,uBAAA;EACA,kFAAA;AAAF;AAEA;EACE,uBAAA;EACA,kFAAA;AAAF;AAEA;EACE,wBAAA;EACA,2FAAA;AAAF;AAIA;EACE,iBAAA;AAFF","sourcesContent":["@import \"@bloglovin/vue-component-library/breakpoint-mixin.scss\";\n@font-face {\n  font-family: 'Starjout';\n  src: url('https://cdn-alpha.inspiration.co/fonts/Starjout.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Starjhol';\n  src: url('https://cdn-alpha.inspiration.co/fonts/Starjhol.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Starjedi';\n  src: url('https://cdn-alpha.inspiration.co/fonts/Starjedi.ttf') format('truetype');\n}\n@font-face {\n  font-family: TradeGothic;\n  src: url(\"https://cdn-alpha.inspiration.co/fonts/Trade-Gothic-Bold.otf\") format(\"opentype\");\n}\n\n\nbody {\n  background: black;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
